import React from 'react';

const Profile: React.FC = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Настройки профиля</h1>
      <p className="text-gray-600">Эта страница будет реализована в следующей итерации.</p>
    </div>
  );
};

export default Profile; 